<template>
    <div>
        <button
                v-on:click="onCustomerNotOkOnPhoneClick"
                v-bind:disabled="state !== 'pristine'"
                class="btn btn-primary">
            {{ 'Customer not ok on the phone' | trans }}
        </button>

        <div
                v-if="errorMessage !== null"
                class="alert alert-danger">
            {{ 'Error' | trans }} - {{ errorMessage }}
        </div>
        <div
                v-else-if="state === 'loading'"
                class="alert alert-info">
            {{ 'Loading' | trans }}...
        </div>
        <template v-else-if="state === 'confirmationAsked'">
            <div class="alert alert-warning">
                {{ 'customer_not_ok_on_phone_refund_warning_part_1' | trans }}
                {{ 'refund_warning_part_2' | trans(refundInfosForDisplay) }}
                <nl2br tag="div" v-bind:text="$options.filters.trans('partial_refund_policy').replace(/_percents_/g, '%')"/>
            </div>
            <div class="row">
                <div class="col-xs-6">
                    <button
                            v-on:click="cancel"
                            class="btn">
                        {{ 'Back' | trans }}
                    </button>
                </div>
                <div class="col-xs-6">
                    <button
                            v-on:click="confirm"
                            class="btn">
                        {{ 'Customer not ok on the phone' | trans }}
                    </button>
                </div>
            </div>
        </template>
        <div
                v-else-if="state === 'confirming'"
                class="alert alert-info">
            {{ 'Sending' | trans }}...
        </div>
        <div
                v-else-if="state === 'confirmed'"
                class="alert alert-success">
            {{ 'Thanks' | trans }} !
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            job: Object,
            user: Object
        },
        data() {
            return {
                errorMessage: null,
                state: 'pristine',
                refundInfos: null,
            }
        },
        methods: {
            async onCustomerNotOkOnPhoneClick() {
                this.state = 'loading';
                if(this.user.workerIsNovice === true){
                    this.state = 'confirmationAsked';
                    this.confirm();
                    return;
                }
                try {
                    this.refundInfos = await this.$api.job.getRefundInfos(this.job.id);
                }
                catch (error) {
                    if (this.$api.is401(error)) {
                        // in case of 401, just abort javascript execution
                        return;
                    }
                    if (this.$api.isNoConnectivity(error)) {
                        this.errorMessage = this.$options.filters.trans('No connection ?');
                    } else {
                        this.$bugsnagClient.notify(error);
                        this.errorMessage = this.$options.filters.trans('Unknown error');
                    }
                    return;
                }
                this.state = 'loaded';
                if (this.refundInfos === null) {
                    this.confirm();
                    return;
                }
                this.state = 'confirmationAsked';

            },
            async confirm() {
                if (['loaded', 'confirmationAsked'].includes(this.state) === false) {
                    return;
                }
                this.state = 'confirming';
                try {
                    await this.$api.job.markAsCustomerNotOkOnPhone(this.job.id);
                }
                catch (error) {
                    if (this.$api.is401(error)) {
                        // in case of 401, just abort javascript execution
                        return;
                    }
                    if (this.$api.isNoConnectivity(error)) {
                        this.errorMessage = this.$options.filters.trans('No connection ?');
                    } else {
                        this.$bugsnagClient.notify(error);
                        this.errorMessage = this.$options.filters.trans('Unknown error');
                    }
                    return;
                }
                this.state = 'confirmed';
                this.$emit('confirmed',this.job);
            },
            cancel() {
                this.state = 'pristine';
            },
        },
        computed: {
            refundInfosForDisplay() {
                if (this.refundInfos === null) {
                    return null;
                }
                return {...this.refundInfos, refundPercentage: this.refundInfos.refundRatio*100 + '%'};
            },
        },
    }
</script>
